export default __webpack_public_path__ + "static/media/3dLanding.e0008d4b.mp4";